import { audioDevicesState } from '@modules/SoftPhoneModule/audioDevicesState';
import { useSnapshot } from 'valtio';

/**
 * Debug view of {@link audioDevicesState} (non-serializable fields summarized).
 */
const AudioDevicesPanel = () => {
  const s = useSnapshot(audioDevicesState);

  const serializable = {
    audioInputDevices: s.audioInputDevices,
    audioOutputDevices: s.audioOutputDevices,
    currentInputDeviceId: s.currentInputDeviceId,
    currentOutputDeviceId: s.currentOutputDeviceId,
    currentRingDeviceId: s.currentRingDeviceId,
    isDevicesReady: s.isDevicesReady,
    errorCategory: s.errorCategory,
    isTestingMicrophone: s.isTestingMicrophone,
    isTestingSpeaker: s.isTestingSpeaker,
    lastSetDevicesError: s.lastSetDevicesError,
  };

  return (
    <div>
      <pre>{JSON.stringify(serializable, undefined, 2)}</pre>
    </div>
  );
};

export default AudioDevicesPanel;
